module.exports = __webpack_public_path__ + "img/rjcStatement@2x.a0336eb.webp";